module.exports = __webpack_public_path__ + "static/media/8-2.3c70e3dd.mp3";